export default "__VITE_ASSET__CMQ_4J78__"